import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useSendProfileToCompany from '../../../../hooks/useSendProfileToCompany'; 
import './profileEmployeeHeader.css'
import useCreateConversation from '../../../../hooks/conversations/useCreateConversation';
import useCheckConversation from '../../../../hooks/conversations/useCheckConversation';
import useSaveTalent from '../../../../hooks/talents/useSaveTalent';
import useSignedImage from '../../../../hooks/useSignedImage';
import { userChefIcon } from '../../../../utils/icons';

const ProfileEmployeeHeader = ({ id, data, handleConversationInitiation }) => {
  const { createConversation, isLoading: conversationLoading, error: conversationError } = useCreateConversation();
  const { checkConversationExistence, conversationExists, conversation } = useCheckConversation();
  const { saveTalent, checkTalentExistence, isLoading, error, talentExist } = useSaveTalent();
  const [imageLoadError, setImageLoadError] = useState(false);

  const handleSaveTalent = async () => {
    if (!isLoading && !talentExist) {
        try {
            await saveTalent(id);
        } catch (error) {
            console.error('Error saving talent:', error);
        }
    }
  };
  
  useEffect(() => {
    checkConversationExistence(id, 'talent');
  }, [ checkConversationExistence]);
 
  useEffect(() => {
    const checkExistence = async () => {
      await checkTalentExistence(id);
    };
    if (id) {
      checkExistence();
    }
  }, [id, checkTalentExistence]);
 
  const startConversation = async () => {
    handleConversationInitiation()
  };
  
  const employeeName = data?.name || 'No hay nombre';
  const employeePosition = data?.role || 'No hay posición';
  const profileImage = data?.information?.profileImageUrl;
  
  // Check if profileImage actually exists and is not empty or a default value
  const hasProfileImage = profileImage && 
    typeof profileImage === 'string' && 
    profileImage.trim() !== '' && 
    profileImage !== 'default-employee.png' && 
    profileImage !== '/default-employee.png' &&
    !profileImage.includes('default');
  
  // Use signed image hook for profile image (only when profileImage exists)
  const { imageUrl: signedProfileImageUrl, isLoading: imageLoading, error: imageError } = useSignedImage(
    hasProfileImage ? profileImage : null, 
    null
  );
  
  return (
    <div className="profile-employee-header__container">
      <div className="profile-employee-header__background-container">
   
      </div>
      <div className="profile-employee-header__image-info-container ">
        <div className="profile-employee-header__avatar-container">
          {imageLoading ? (
            <div className="profile-employee-header__loading">Loading...</div>
          ) : hasProfileImage && !imageLoadError ? (
            <img 
              id="profile-employee-header__img" 
              src={signedProfileImageUrl} 
              alt="Avatar"
              onError={(e) => {
                setImageLoadError(true);
                e.target.style.display = 'none';
              }}
            />
          ) : (
            <div className="profile-employee-header__icon-placeholder">
              {userChefIcon}
            </div>
          )}
        </div>
        <div className="profile-employee-header__info-container">
          <div className="profile-employee-header__text-info">
            <h1 className="profile-employee-header__name">{employeeName}</h1>
            <h2 className="profile-employee-header__company">{employeePosition}</h2>
           
          </div>
          <div className="profile-employee-header__buttons">
            <button className="profile-employee-header__button" onClick={startConversation}>
              {conversationExists ? 'Chat' : 'Contactar' } 
            </button>
            <button 
                onClick={handleSaveTalent}
                className="profile-employee-header__button"
                disabled={isLoading || talentExist}
            >
                {talentExist ? 'Guardado' : 'Guardar'}
            </button>
          </div>
        </div>  
      </div>
    </div>
  );
};

export default ProfileEmployeeHeader;